<div class="agendar-atendimento-container">
  <div class="header">
    <div class="row align-items-center">
      <div class="col-md-8">
        <h1>Agendar Atendimento</h1>
      </div>
    </div>
  </div>

     <!-- Formulário -->
   <div class="formulario-container">
     
     <!-- Card Assessor -->
     <div class="card mb-4">
       <div class="card-header">
         <h5 class="mb-0"><i class="fa fa-user-tie"></i> Assessor</h5>
       </div>
       <div class="card-body">
         <div class="row">
           <div class="col-md-6 col-sm-12">
             <div class="form-group">
               <label for="assessor">Assessor:</label>
               <select
                 id="assessor"
                 class="form-control"
                 [(ngModel)]="formData.assessorId">
                 <option value="">Selecione um assessor</option>
                 <option *ngFor="let assessor of assessores" [value]="assessor.id">
                   {{ assessor.nome }} - {{ assessor.email }}
                 </option>
               </select>
             </div>
           </div>
         </div>
       </div>
     </div>

     <!-- Card Cliente e Tipo -->
     <div class="card mb-4">
       <div class="card-header">
         <h5 class="mb-0"><i class="fa fa-users"></i> Cliente e Tipo de Atendimento</h5>
       </div>
       <div class="card-body">
         <div class="row">
           <div class="col-md-6 col-sm-6 mb-3">
             <div class="form-group">
               <label for="cliente">Cliente:</label>
              <div class="input-group position-relative">
                <input
                  id="cliente"
                  type="text"
                  class="form-control"
                  [(ngModel)]="clienteBusca"
                  (input)="onClienteInputChange()"
                  (focus)="abrirListaClientes()"
                  (blur)="fecharListaClientesComDelay()"
                  placeholder="Selecione ou busque cliente por nome/e-mail">
                 <button type="button" class="btn btn-outline-primary" (click)="cadastroRapido()">
                   <i class="fa fa-plus"></i> Cadastro Rápido
                 </button>

                <div
                  class="list-group position-absolute w-100 mt-1"
                  style="top: 100%; z-index: 1000; max-height: 260px; overflow-y: auto;"
                  *ngIf="mostrarListaClientes">
                  <button
                    type="button"
                    class="list-group-item list-group-item-action"
                    *ngFor="let cliente of clientesFiltrados"
                    (mousedown)="selecionarCliente(cliente)">
                    {{ cliente.nome }}<span *ngIf="cliente.email"> - {{ cliente.email }}</span>
                  </button>
                  <div class="list-group-item text-muted" *ngIf="clientesFiltrados.length === 0">
                    Nenhum cliente encontrado
                  </div>
                </div>
               </div>
             </div>
           </div>
           <div class="col-md-6 col-sm-6 mb-3">
             <div class="form-group">
               <label for="tipo">Tipo:</label>
               <select
                 id="tipo"
                 class="form-control"
                 [(ngModel)]="formData.tipoId">
                 <option value="">Selecione um tipo</option>
                 <option *ngFor="let tipo of tipos" [value]="tipo.id">
                   {{ tipo.nome }}
                 </option>
               </select>
             </div>
           </div>
         </div>
       </div>
     </div>

           <!-- Card Datas e Configurações -->
      <div class="card mb-4">
        <div class="card-header">
          <h5 class="mb-0"><i class="fa fa-calendar-alt"></i> Datas e Configurações</h5>
        </div>
        <div class="card-body">
          <!-- Primeira linha: Criar Sala, Data Início, Data Fim -->
          <div class="row">
            
            <div class="col-md-5 col-sm-6 mb-3">
              <div class="form-group">
                <label for="dataInicio">Data Início:</label>
                <input
                  type="datetime-local"
                  id="dataInicio"
                  class="form-control"
                  [(ngModel)]="formData.dataInicio">
              </div>
            </div>
            <div class="col-md-5 col-sm-6 mb-3">
              <div class="form-group">
                <label for="dataFim">Data Fim:</label>
                <input
                  type="datetime-local"
                  id="dataFim"
                  class="form-control"
                  [(ngModel)]="formData.dataFim">
              </div>
            </div>
          </div>
          <!-- Segunda linha: Data Expiração e Enviar Cliente -->
          <div class="row">
            <div class="col-md-12 col-sm-12 mb-3">
              <div class="form-group">
                <label for="criarSala">Criar Sala:</label>
                <div class="toggle-container mt-2">
                  <label class="toggle-switch">
                    <input
                      type="checkbox"
                      id="criarSala"
                      [(ngModel)]="formData.criarSala">
                    <span class="toggle-slider"></span>
                  </label>
                  <span class="toggle-label">{{ formData.criarSala ? 'Sim' : 'Não' }}</span>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-sm-6 mb-3">
              <div class="form-group">
                <label for="dataExpiracao">Data Expiração:</label>
                <input
                  type="datetime-local"
                  id="dataExpiracao"
                  class="form-control"
                  [(ngModel)]="formData.dataExpiracao">
              </div>
            </div>
            <div class="col-md-6 col-sm-6 mb-3">
              <div class="form-group">
                <label for="enviarParaCliente">Enviar Cliente:</label>
                <div class="toggle-container mt-2">
                  <label class="toggle-switch">
                    <input
                      type="checkbox"
                      id="enviarParaCliente"
                      [(ngModel)]="formData.enviarParaCliente">
                    <span class="toggle-slider"></span>
                  </label>
                  <span class="toggle-label">{{ formData.enviarParaCliente ? 'Sim' : 'Não' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

           <!-- Card Observação -->
      <div class="card mb-4">
        <div class="card-header">
          <h5 class="mb-0"><i class="fa fa-sticky-note"></i> Observações</h5>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label for="observacao">Observação:</label>
                <textarea
                  id="observacao"
                  class="form-control"
                  rows="4"
                  [(ngModel)]="formData.observacao"
                  placeholder="Observações sobre o atendimento"></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>

     <!-- Card Ações -->
     <div class="card">
       <div class="card-body">
         <div class="row">
           <div class="col-12 text-end">
             <button class="btn btn-secondary me-2" (click)="limparFormulario()">
               <i class="fa fa-times"></i> Limpar
             </button>
             <button class="btn btn-primary" (click)="agendarAtendimento()">
               <i class="fa fa-calendar-plus"></i> Agendar Atendimento
             </button>
           </div>
         </div>
       </div>
     </div>
   </div>


</div> 